import { Trans } from '@lingui/react/macro';
import { Badge } from '@repo/videa-components/src/ui/badge';
import classNames from 'classnames';
import { format } from 'date-fns';

export const ScheduledTreatmentBadge = ({
  scheduledToday,
  scheduledDate,
  isDarkMode,
}: {
  scheduledToday: boolean;
  scheduledDate: string;
  isDarkMode?: boolean;
}) => {
  if (scheduledToday) {
    return (
      <Badge
        className={classNames(
          'vai-rounded-xl vai-py-1 vai-px-2 vai-font-inter',
          {
            'vai-bg-slate-400 hover:vai-bg-slate-400': !isDarkMode,
            'vai-bg-slate-500 hover:vai-bg-slate-500': isDarkMode,
          },
        )}
      >
        <p>
          <Trans>Today</Trans>
        </p>
      </Badge>
    );
  }

  if (scheduledDate) {
    return (
      <Badge
        className={classNames(
          'vai-rounded-xl vai-py-1 vai-px-2 vai-font-inter',
          {
            'vai-bg-slate-400 hover:vai-bg-slate-400': !isDarkMode,
            'vai-bg-slate-500 hover:vai-bg-slate-500': isDarkMode,
          },
        )}
      >
        <p>{format(new Date(scheduledDate), 'MM/dd/yy')}</p>
      </Badge>
    );
  }

  return null;
};
